import React, { Component } from 'react';
import PropTypes from 'prop-types';
// TODO: fix issue with eslint import resolver
import { connect } from 'react-redux'; // eslint-disable-line import/no-unresolved
import { Common } from 'ws-scripts/modules/common';
import { ErrorBoundary } from 'wsm-error-boundary';
import QuickSpecs from '../components/QuickSpecs';
import { QuickSpecsIDC } from '../components/QuickSpecsIDC';
import { FLAG_ENABLE_IDC_SERVICE } from '../global-constants';

class WidgetContainer extends Component {
	render() {
		if (!this.props.quickSpecs) {
			return null;
		}

		return (
			<ErrorBoundary newRelicPageAction="WS QUICK SPECS ERROR BOUNDARY">
				<Common
					render={({ labels, flags }) => {
						return (
							<>
								{flags[FLAG_ENABLE_IDC_SERVICE] ? (
									<QuickSpecsIDC
										quickSpecs={this.props.quickSpecsIDC}
										deviceType={this.props.deviceType}
									/>
								) : (
									<QuickSpecs
										quickSpecs={this.props.quickSpecs}
										deviceType={this.props.deviceType}
										vehicleType={this.props.vehicleType}
										labels={labels}
									/>
								)}
							</>
						);
					}}
				/>
			</ErrorBoundary>
		);
	}
}

WidgetContainer.propTypes = {
	deviceType: PropTypes.string.isRequired,
	quickSpecs: PropTypes.shape({}).isRequired,
	quickSpecsIDC: PropTypes.shape([]).isRequired,
	vehicleType: PropTypes.string.isRequired
};

const mapStateToProps = state => {
	return {
		quickSpecs: state.quickSpecs,
		vehicleType: state.vehicleType,
		deviceType: state.requestData.deviceType,
		quickSpecsIDC: state.quickSpecsIDC
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
